import { Action } from 'redux';

import { NewWorkbookForEditDatasource } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { IContentInfo } from '../../ts/models/IContentInfo';


export interface EditDatasourceAction extends Action {
  skipPrepCheck: boolean;
  contentInfo: IContentInfo;
}

export function editDatasource(contentInfo: IContentInfo, skipPrepCheck: boolean): EditDatasourceAction {
  return {
    type: NewWorkbookForEditDatasource,
    skipPrepCheck,
    contentInfo
  };
}

export const isEditDatasourceAction = isActionFactory<EditDatasourceAction>(NewWorkbookForEditDatasource);
